import React from 'react';

const ConfidenceDonut = ({ score = 0, size = 80, strokeWidth = 8, label = 'Confiance' }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (score / 100) * circumference;
    const center = size / 2;

    // Color based on score
    const getColor = (s) => {
        if (s >= 90) return { stroke: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.1)' }; // violet
        if (s >= 75) return { stroke: '#3b82f6', bg: 'rgba(59, 130, 246, 0.1)' }; // blue
        return { stroke: '#94a3b8', bg: 'rgba(148, 163, 184, 0.1)' }; // slate
    };

    const colors = getColor(score);

    return (
        <div className="flex flex-col items-center gap-1">
            <svg width={size} height={size} className="transform -rotate-90">
                {/* Background circle */}
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke="#e2e8f0"
                    strokeWidth={strokeWidth}
                />
                {/* Progress arc */}
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke="url(#donutGradient)"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dashoffset 0.8s ease-in-out' }}
                />
                <defs>
                    <linearGradient id="donutGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#3b82f6" />
                        <stop offset="100%" stopColor="#8b5cf6" />
                    </linearGradient>
                </defs>
            </svg>
            {/* Score text overlay */}
            <div
                className="absolute flex flex-col items-center justify-center"
                style={{ width: size, height: size }}
            >
                <span className="text-lg font-black text-slate-800">{score}%</span>
            </div>
            {label && (
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{label}</span>
            )}
        </div>
    );
};

export default ConfidenceDonut;
